const general = {
  controller: 'Contrôleur',
  add_controller: 'Nouveau Contrôleur',
  search_serial_number: 'Rechercher le numéro de série',
  register_msg:
    'Connectez le premier contrôleur au réseau, remplissez le numéro de série et appuyez sur enregistrer pour continuer',
  serial_number: 'Numéro de série',
  new_serial_number: 'Nouveau Numéro de série',
  register: 'Enregistrer',
  setup: 'Installation',
  doors: 'Portes',
  doors_activation: 'Activation des portes',
  finish: 'Finir',
  reboot: 'Redémarrer',
  enable_door: 'Etes-vous sûr de vouloir activer la porte {{door}}?',
  disable_door: 'Etes-vous sûr de vouloir désactiver la porte',
  confirm_selected_controller:
    'Etes-vous sûr de vouloir enregistrer ce contrôleur {{controller}} sur le site {{site}}',
  confirm_delete_firmware_available:
    'Êtes-vous sûr de vouloir supprimer la version du micrologiciel {{version}}?',
  choose_controller_msg:
    "Choisissez un contrôleur et cliquez pour l'enregistrer",
  processing_controller: 'Traitement du nouveau contrôleur sur le réseau.',
  reboot_message: 'Redémarrage du contrôleur. Veuillez patienter 60 secondes:',
  door_info_message:
    'Récupération des informations sur la porte. Veuillez patienter 60 secondes :',
  rebooting_controller: 'Redémarrage du contrôleur',
  replace_controller_title: 'Remplacer le contrôleur',
  replace_action_title: 'Action de remplacement',
  replace_process_title: 'Processus de remplacement',
  form: {
    enable_ip: 'Activer la configuration IP',
    dns: 'DNS IP',
    use_dhcp: 'Utiliser DHCP',
    subnet_mask: 'Masque de sous-réseau',
    ip_address: 'Adresse IP',
    webport: 'Port Internet',
    ip_format_error: 'Format incorrect (xxx.xxx.xxx.xxx)',
    mac_address: 'Adresse Mac',
    gateway: 'Passerelle',
    showTampered: 'Afficher les options anti-sabotage',
    tabControllerData: 'Données du contrôleur',
    tabControllerTamper: 'Anti-sabotage',
  },
  register_steps: 'Étape {{step}} / 6',
  register_steps_alt: 'Étape {{step}} / 7',
  steps: {
    step1: 'Tester la connexion du contrôleur',
    step2: "Récupérer le code d'enregistrement",
    step3: 'Attribuer au site cloud',
    step4: 'Génération des identifiants',
    step5: 'Tester les identifiants',
    step6: 'Connecté!',
    step7: 'Attachement au site',
  },
  register_error:
    "Une erreur s'est produite sur l'une des étapes, veuillez réessayer",
  errors: {
    ping: 'Erreur lors de la connexion au contrôleur, veuillez vérifier le numéro de série',
    verification_code:
      'Erreur lors de la récupération du code de vérification, veuillez vérifier la connexion du contrôleur',
    assign:
      "Erreur lors de l'attribution du contrôleur au site, veuillez réessayer",
  },
  ping_successful: 'Test du contrôleur réussi',
  ping_unsuccessful: 'Test du contrôleur échoué',
  to_continue: 'Pour continuer',
  ping_successful_msg:
    'Cliquez sur le lien suivant pour obtenir le code de vérification',
  verification_code: 'Remplissez le code de vérification ici',
  back: 'Retour',
  assign: 'Attribuer',
  ping_verify:
    'Le ping vers {{serial_number}} a réussi, le contrôleur est actif',
  ping_verify_fail:
    'Aucune réponse reçue du contrôleur {{serial_number}}, le contrôleur est hors ligne',
  buttonRestore: 'Restaurer',
  tampered: 'Sabotage',
  tamperedAlarm: 'Alarme de sabotage',
  tamperedNormal: 'Normal',
  tamperedEnableCheck: 'Activer',
  tamperedAlarmCheck: 'Alarme',
  tamperedRestoreSuccess: "Restauration de l'alarme du contrôleur réussie",
  readers: 'Lecteurs',
  tamperUpdateSuccess: "Options d'anti-sabotage mises à jour avec succès",
  reader_alarm_restore_success: 'Alarme du lecteur rétablie avec succès',
  reader_deleted_successfully: 'Lecteur supprimé avec succès',
  readersTab: {
    readerPort: 'Port de Lecteurs',
    EditReaderModal: {
      editReader: 'Modifier le lecteur',
      displayName: "Nom d'affichage",
      productCode: 'Code produit',
      port: 'Port',
      firmware: 'Micrologiciel',
    },
  },
  select_controller_replace: 'Sélectionnez un contrôleur à remplacer',
  process_irreversible:
    'Ce processus est irréversible <br/> Vous pouvez fermer cette fenêtre et revenir à tout moment.',
  press_done_msg:
    'Remplacement terminé, appuyez sur <strong>Terminé</strong> pour fermer la fenêtre',
  confirmation_door_msg:
    'Êtes-vous sûr de vouloir {{dooorAction}} la {{doorStatus}} porte?',
  confirmation_reboot_msg:
    'Êtes-vous sûr de vouloir redémarrer le contrôleur {{controller}}?',
  replace_action: {
    validations: 'Validations générales',
    gencreds: "Génération d'identifiants",
    testcreds: 'Tester les identifiants',
    connected: 'Contrôleur connecté',
    ismain: 'Le contrôleur est le contrôleur maître de ce site',
    modulerestartbegin: 'Le contrôleur redémarre',
    modulerestartend: 'Le contrôleur est en ligne',
    getrectableinfo: "Collecte d'informations sur les entités",
    getdoor: "Collecte d'informations sur les portes",
    getdoorlock: "Collecte d'informations sur les serrures de porte",
    getinputlogic: 'Collecte des informations des entrées',
    getoutput: 'Collecte des informations des sorties',
    getreader: 'Collecte des informations sur les lecteurs',
    getmodtable: "Collecte d'informations sur les modules",
    getipconn: 'Récupérer la configuration IP',
    setrtc: 'Configuration du fuseau horaire',
    setsubcontroller: 'Configuration des sous-contrôleurs',
    setglobalsite: 'Configuration du site global',
    setdesfireapp: "Configuration du maître d'ID d'application Desfire",
    setreadermode: 'Mettre les lecteurs en mode autoprogrammation',
    setholiday: 'Définir les jours fériés',
    setschedule: 'Définir les horaires',
    setaccesslevel: "Définir les niveaux d'accès",
    setdoor: 'Définir les portes',
    setfactorydefault:
      "Définir les paramètres d'usine par défaut sur l'ancien contrôleur",
    removecontroller: "Supprimer l'ancien contrôleur du site",
    finished: 'Remplacement terminé',
  },
  table_controller_type: 'Type de contrôleur',
  table_ip_address: 'Adresse IP',
  table_port: 'Port',
  table_door: 'Porte',
  table_status: 'Statut',
  table_firmware_version: 'Version du micrologiciel',
  table_actions: 'Actions',
  mandatory_update: 'Mise à jour obligatoire',
  update_firmware: 'Mettre à jour le micrologiciel',
  table_aria_label: 'Tableau des contrôleurs',
  readers_table_aria_label: 'Liste des lecteurs',
  all_steps: 'Toutes les étapes',
  view_syncing: 'Afficher le processus de synchronisation',
  syncing: 'Synchronisation',
  synced: 'synchronisé',
  enabling: 'Activation',
  sync: {
    ctrl: ' Configuration de configuration du contrôleur rassemblée ',
    door: 'Portes rassemblées',
    output: 'Sorties rassemblés',
    reader: 'Lecteurs rassemblés',
    input: 'Entrées rassemblées',
    doorlock: ' Les serrures de porte rassemblées',
    holiday: ' Jours fériés rassemblées ',
    schedule: ' Horaires rassemblés ',
    al: " Niveaux d'accès rassemblés ",
    tamper: ' Tampers Cfg rassemblés ',
    timezone: 'Définir le fuseau horaire',
    global_site: 'Définir le site global',
    krypto: 'Sécurité Krypto activée',
    set_reader: ' Mise en mode autoprogrammation des lecteurs ',
    lockdown: 'Définir le confinement',
    set_holiday: 'Définir les jours fériés',
    set_schedule: ' Définir les horaires ',
    set_al: "Définir les niveaux d'accès",
    set_user: 'Définir les utilisateurs',
    set_card: "Définir les informations d'identification",
    synced: 'Synchronisé',
  },
  synced_msg: {
    reader_synced: 'Lecteurs',
    io_synced: 'Entrées/Sorties',
    al_synced: "Niveau d'accès",
    tz_synced: 'Fuseau horaire',
    krypto: 'Sécurité Krypto',
  },
  atrium_unavailable_msg:
    "Aucun contrôleur n'est connecté pour le moment, essayez lorsqu'au moins un de vos contrôleurs est en ligne.",
  door_activation: 'Activation de la porte',
  remove_confirm_message:
    'Êtes-vous sûr de vouloir SUPPRIMER ce contrôleur - {{serial}} ?',
  remove_irreversible:
    'Cette action est irréversible et supprimera toutes les informations du contrôleur.',
  connecting_controller: 'Nous essayons de nous connecter au contrôleur.',
  message_title: 'Message',
  controller_offline_confirm:
    'Votre contrôleur semble hors ligne. Voulez-vous continuer à le retirer ?',
  manual_factory_reset:
    'Si vous continuez, vous devrez effectuer une réinitialisation usine manuelle sur le contrôleur.',
};

export default general;
